import { Component, Vue } from "vue-property-decorator";
import md5 from 'md5';

class DATA extends Vue {
  tableData: Array<any> = [];
  loading: boolean = false;
  pageNo: number = 1;
  total: number = 1;
  size: number = 1;
  types: Array<string> = [, "淘宝", "PR", "第三方商户", "未知"];
  status: Array<string> = ["未知", "正常", "禁用"];
  statusColor: Array<string> = ["info", "success", "danger"];
  dialog: boolean = false;

  currentEdit: any = {
    id: null,
    password: null,
    rePassword: null,
    nickName: null,
    phone: null,
    shopName: null,
    appId: null,
    secretKey: null,
    type: null,
    prefix: null,
    status: null
  };
  orderType: number = null;
}

@Component
export default class Index extends DATA {
  created() {
    this.getList();
  }

  getList() {
    this.$api
      .getMerchantList({ pageNo: this.pageNo })
      .then(({ data: { status, data, msg } }) => {
        if (status == 200) {
          this.tableData = data.records;
          this.total = data.total;
          this.size = data.size;
        } else {
          this.$message.error(msg);
        }
      });
  }
  operateMerchant(orderType: number, row: any) {
    this.orderType = orderType;
    Object.keys(this.currentEdit).forEach(
      key => (this.currentEdit[key] = null)
    );
    if (orderType === 2) {
      this.currentEdit = { ...row };
    }
    this.dialog = true;
  }
  saveMerchant() {
    let { orderType, currentEdit } = this;
    let postData = { ...currentEdit };

    let {
      password,
      rePassword,
      nickName,
      phone,
      type,
      prefix,
      shopName,
      pushMode
    } = postData;

    let filterKey = ["appId", "secretKey", "phone", "createTime", "updateTime"];

    if (!nickName) {
      return this.$message.error("用户昵称不可为空");
    }
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
      return this.$message.error("手机号码格式错误");
    }
    if (orderType === 1) {
      if (!password || password.length < 9) {
        return this.$message.error("密码必须大于八位字符");
      }
      if (password !== rePassword) {
        return this.$message.error("密码输入不一致");
      }
    } else {
      if (password) {
        if (password.length < 9) {
          return this.$message.error("密码必须大于八位字符");
        }
        if (password !== rePassword) {
          return this.$message.error("密码输入不一致");
        }
      }
    }
    if (!shopName) {
      return this.$message.error("店铺名称不可为空");
    }
    if (!prefix) {
      return this.$message.error("订单前缀不可为空");
    }
    if (type === null) {
      return this.$message.error("类型不可为空");
    }
    Object.keys(postData).forEach(key => {
      if (postData[key] === null) delete postData[key];
      if (orderType === 2) {
        if (filterKey.includes(key)) delete postData[key];
      }
    });

    const data = { ... postData };
    if (data.password) {
      data.password = md5(postData.password)
    }
    if (data.rePassword) {
      data.rePassword = md5(postData.rePassword)
    }
    this.$api
      .saveMerchant(
        orderType === 1 ? "/api/user/add" : "/api/user/updateById",
        { ...data }
      )
      .then(({ data: { status, data, msg } }) => {
        if (status == 200) {
          this.dialog = false;
          this.$message({
            type: "success",
            message: `${orderType === 1 ? "新增" : "修改"}成功!`
          });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      });
  }

  handlePageChange(e) {
    this.pageNo = e;
    this.getList();
  }
}
